export default () => ({
  activeImage: null,
  opened: false,
  close() {
    if(this.opened) {
      document.body.style.overflow = 'initial'
      this.activeImage = null
      this.opened = false
    }
  },
  open(event) {
    document.body.style.overflow = 'hidden'
    this.activeImage = event.detail.image
    this.opened = true
  }
})
